module.exports = __webpack_public_path__ + "01_short_yellow.7fa5de50.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/boy/layer5/01_short_yellow.png
// module id = dB1S
// module chunks = 0